import React, { createElement, useEffect, useState } from 'react';
import { Cascader, Form, Col } from 'antd';
import { generateRules } from '../../../utils';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
import { getDeptTree } from "../../../api/form";
const { SHOW_CHILD } = Cascader;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const displayRender = (labels) => labels[labels.length - 1];
const FormCascaderMultiple = (props, ref) => {
    const { isNecessary, verifytext, title, __id, rules, status, span, column, options, dynamicOptions, ...other } = props;
    const [rule, setRule] = useState([]);
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [ops, setOps] = useState([]);
    useEffect(() => {
        if (props?.dynamic) {
            if (dynamicOptions === '组织树') {
                getDeptTree().then((res) => {
                    setOps(res.data);
                });
            }
        }
        else {
            setOps(options);
        }
    }, []);
    useEffect(() => {
        setError(false);
        try {
            setRule(generateRules(rules, 'array'));
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('校验规则初始化出错,检查配置或更新组件');
        }
    }, [rules]);
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement(Col, { span: column || span },
        createElement("div", { ref: ref, className: "base_bg" },
            createElement(Form.Item, { label: title || '级联复选', name: __id || props.componentId, rules: rule },
                createElement(Cascader, Object.assign({ disabled: status === 'readonly' || urlParams.get('edit') === '3' }, other, { displayRender: displayRender, multiple: true, showCheckedStrategy: SHOW_CHILD, options: ops }))))))));
};
export default React.forwardRef(FormCascaderMultiple);
